export const asDataMode = (mode = "real", overrides = {}) => ({
  mode,
  label: mode === "real" ? "Real data" : mode === "partial" ? "Partial data" : mode === "demo" ? "Demo" : "Mock data",
  source: mode === "real" ? "Absolluty API" : "Frontend fixture",
  ...overrides,
});

const measuredNumber = (value) => value === null || value === undefined || value === "" || !Number.isFinite(Number(value)) ? "-" : Number(value);

export const normalizeCameraHealth = (camera) => ({
  id: camera.id || camera.name,
  name: camera.display_name || camera.name || "Camera",
  status: camera.status || "unknown",
  fps: measuredNumber(camera.fps ?? camera.current_fps),
  latencyMs: measuredNumber(camera.latency_ms ?? camera.latency),
  bitrate: camera.bitrate || "-",
  droppedFrames: measuredNumber(camera.dropped_frames),
  uptime: camera.uptime_percentage === null || camera.uptime_percentage === undefined
    ? (camera.uptime ?? "-")
    : `${camera.uptime_percentage}%`,
  aiState: camera.ai_state || camera.processing_state || "unknown",
});

export const normalizeIncidentFromAlert = (alert) => ({
  id: alert.incident_id || `ALT-${alert.id}`,
  storeId: alert.branch_id || alert.store_id || "",
  severity: alert.severity || "MEDIUM",
  status: alert.status || "New",
  riskScore: Math.round(Number(alert.confidence_score || 0.5) * 100),
  events: 1,
  cameras: alert.camera_id ? 1 : 0,
  startedAt: alert.occurred_at || alert.created_at,
  duration: alert.duration_ms ? `${Math.round(Number(alert.duration_ms) / 1000)}s` : "-",
  title: String(alert.detection_type || alert.title || "AI event").replace(/_/g, " "),
  zone: alert.zone_name || "",
});

